/**
* this is the dashboard item component that includes the empty state
* the loader state and the chart/list
*
* Created by Tom on 12/06/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// component import
import DashboardLoader from '../../components/DashboardLoader/'
import EmptyData from '../../components/EmptyData/'
import Transaction from '../../components/Transaction/'
import Investment from '../../components/Investment/'
import Portfolio from '../../components/Portfolio/'
import News from '../../components/News/'

// style import
import './style.scss'

class DashboardItem extends Component {

    renderSwitch() {
        const { type } = this.props

        // return the correct component based on the type
        switch (type) {
            case 'investment': return (<Investment />)
            case 'portfolio': return (<Portfolio />)
            case 'transaction': return (<Transaction />)
            case 'news': return (<News />)

            default: return (null)
        }
    }

    render() {

        const { isLoading, data, headerText, type } = this.props

        // show/hide loader based on the truthy value 'isLoading'
        const dynClassLoader = cx('dashboard-item__loader', {
            'dashboard-item__loader--show': isLoading
        })

        // show/hide empty image based on whether there is 'data' to be displayed
        const dynClassEmpty = cx('dashboard-item__empty', {
            'dashboard-item__empty--show': !data.length && !isLoading
        })

        // show/hide the graph/news based on whether there is 'data' to be displayed
        const dynClassGraph = cx('dashboard-item__graph', {
            'dashboard-item__graph--show': data.length && !isLoading
        })

        return (
            <div className="dashboard-item">

                {/* loader component */}
                <div className={dynClassLoader}>
                    <DashboardLoader type={type} />
                </div>

                {/* empty component */}
                <div className={dynClassEmpty}>
                    <EmptyData headerText={headerText}/>
                </div>

                {/* graph/table components */}
                <div className={dynClassGraph}>
                    {/* switch component based on the type */}
                    {::this.renderSwitch()}
                </div>

            </div>
        )
    }
}

// define the prop types
DashboardItem.propTypes = {
    isLoading: PropTypes.bool,
    data: PropTypes.array,
    headerText: PropTypes.string,
    type: PropTypes.string
}

export default DashboardItem



// WEBPACK FOOTER //
// ./src/components/DashboardItem/index.js